"use client";

import { ButtonComponent } from "@/components";
import { useEffect } from "react";
import { WEB_COLORS } from "@/lib/constants";

export default function Error({ error, reset }) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error);
  }, [error]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        padding: "20px",
        textAlign: "center",
      }}>
      <h2
        style={{
          fontSize: "clamp(1.5rem, 5vw, 2rem)",
          fontWeight: 600,
          marginBottom: "16px",
          color: WEB_COLORS.primary,
        }}>
        Something went wrong!
      </h2>
      <p
        style={{
          fontSize: "clamp(0.875rem, 3vw, 1rem)",
          color: WEB_COLORS.grey,
          marginBottom: "24px",
          maxWidth: "500px",
          width: "100%",
        }}>
        We apologize for the inconvenience. Please try again.
      </p>
      <ButtonComponent
        style={{
          width: "clamp(120px, 50vw, 200px)",
          padding: "12px 24px",
          fontSize: "clamp(0.875rem, 3vw, 1rem)",
        }}
        onClick={
          // Attempt to recover by trying to re-render the segment
          () => reset()
        }>
        Try again
      </ButtonComponent>
    </div>
  );
}
